import React, { Component } from 'react'
import { Link, Redirect } from "react-router-dom"
import { formPagePath } from '../utilities/route'
import Logo from '../images/logo-engager.svg'
import LogoMobile from '../images/logo-engager-mobile.svg'
import FrontSection1Bg from '../images/front-section1-bg.png'
import FrontSection2Bg from '../images/front-section2-bg.png'
import Arrow from '../images/arrow.svg'
import RuleOne1x from '../images/rule-one.png'
import RuleOne2x from "../images/rule-one@2x.png"
import RuleTwo1x from "../images/rule-two.png"
import RuleTwo2x from "../images/rule-two@2x.png"
import RuleThree1x from "../images/rule-three.png"
import RuleThree2x from "../images/rule-three@2x.png"
import LanguageSelector from "../containers/language-selector"
import { isRetina } from '../utilities/helpers'
import ServerImage from './server-image'
import Modal from "reactstrap/lib/Modal"
import ModalHeader from "reactstrap/lib/ModalHeader"
import ModalBody from "reactstrap/lib/ModalBody"
import ModalFooter from "reactstrap/lib/ModalFooter"
import MediaList from './media-list'
import Button from './ui/button'

class LandingPage extends Component {

  executeScroll = (refName) => {
    this[refName].scrollIntoView({ behavior: "smooth" });
  };

  getPrivacyPolicyLabel(languageCode, surveyId) {
    const {
      useTranslate,
    } = this.props;

    const t = (phrase) => useTranslate(`landing.${phrase}`);

    return (
      <Link className="mr-5" to={formPagePath(languageCode, surveyId, 'privacy-policy')}>
        {t("privacy_policy")}
      </Link>
    );
  }

  closeModal = () => {
    const {
      history,
      match: { url },
    } = this.props;

    history.push(url);
  };

  renderPrivacyPolicy() {
    const {
      match: { url },
      location: { pathname },
      useTranslate,
    } = this.props;
    const isOpen = !!pathname.match(/privacy-policy/);
    const t = (phrase) => useTranslate(`privacy_policy.${phrase}`);

    return (
      <Modal isOpen={isOpen} toggle={this.closeModal} className="modal-lg">
        <ModalHeader toggle={this.closeModal}>{t("privacy_policy_title")}</ModalHeader>
        <ModalBody>
          <div
            className="privacy-policy-full"
            dangerouslySetInnerHTML={{ __html: t("privacy_policy_text") }}
          />
        </ModalBody>
        <ModalFooter>
          <Button as={Link} to={url} size={"md"}>{t("accept")}</Button>
        </ModalFooter>
      </Modal>
    );
  }

  render() {
    const {
      match: {
        params: { surveyId, languageCode },
      },
      useTranslate,
      questionnaire: {
        logo,
        media,
        canChooseParameterOptions,
        isFinished,
        canViewAfterGame,
        isAfterGameGuest,
        canAnswer,
        catalysts,
        hideCatalystThemePages
      },
    } = this.props;

    /* Aftergame guest */
    if (isAfterGameGuest) {
      return <Redirect to={formPagePath(languageCode, surveyId, 'finish')} />;
    }

    /* Finished questionnaire and aftergame is not on yet */
    if (isFinished && !canViewAfterGame && !sessionStorage.getItem("surveyBeingEdited")) {
      return <Redirect to={formPagePath(languageCode, surveyId, 'finish')} />;
    }

    /* Finished questionnaire and aftergame is on*/
    if (!canAnswer && !canChooseParameterOptions) {
      return <Redirect to={formPagePath(languageCode, surveyId, 'finish')} />;
    }

    /* Invited user is late to questionnaire */
    if (!canAnswer && !canViewAfterGame && !isFinished && canChooseParameterOptions && !isAfterGameGuest ) {
      return <Redirect to={formPagePath(languageCode, surveyId, 'finish')} />;
    }

    /* ? aftergame on and late? */
    if (canViewAfterGame && canChooseParameterOptions) {
      return <Redirect to={formPagePath(languageCode, surveyId, 'background')} />
    }

    const t = (phrase) => useTranslate(`landing.${phrase}`);

    const startUrl = (!canViewAfterGame)
      ? formPagePath(languageCode, surveyId, 'background')
      : hideCatalystThemePages
        ? formPagePath(languageCode, surveyId, 'catalyst', catalysts[0].id, 'questions')
        : formPagePath(languageCode, surveyId, 'catalyst', catalysts[0].id);

    return (
      <div className="landing position-relative">
        <section className="front d-flex align-items-center justify-content-center">
          <nav className="w-100 nav nav-landingpage d-flex align-items-center justify-content-between">
            <Link to={formPagePath(languageCode, surveyId)} className="navbar-brand">
              <img src={Logo} alt={"engager"} className="d-none d-md-block engager-logo-desktop" />
              <img src={LogoMobile} alt={"engager"} className="d-block d-md-none engager-logo-mobile" />
            </Link>
            <div className="nav-items">
              <div
                onClick={() => this.executeScroll("aboutRef")}
                className="nav-item hover scroll-to"
              >
                {t("about")}
              </div>
              <div
                onClick={() => this.executeScroll("rulesRef")}
                className="nav-item hover scroll-to"
              >
                {t("rules")}
              </div>
              <LanguageSelector />
            </div>
          </nav>
          <div className="front__hero">
            <div className="front__hero__content">
              {logo && logo.key && (
                <div className="logo-client">
                  <ServerImage image={logo && logo.key}>
                    {({ uri }) => <img src={uri} alt="Logo" />}
                  </ServerImage>
                </div>
              )}
              <div className="front__hero__welcome serif-text-lg">{t("welcome")}</div>
              <h1>{t("title")}</h1>
              <div className="front__hero__welcome">{t("subtitle")}</div>
              <Button as={Link} to={startUrl}>{t("start_btn")}</Button>
            </div>
            <div className="arrow-container">
              <span className="scroll-txt">{t("scroll_down_button_text")}</span>
              <img
                className="arrow-img"
                alt=""
                src={Arrow}
              />
            </div>
            <div className="section-bg">
              <img src={FrontSection1Bg} alt="Shapes"/>
            </div>
          </div>
        </section>
        <section
          ref={(ref) => {
            this.aboutRef = ref;
          }}
          className="about d-flex justify-content-center align-items-center"
        >
          <div className="about-container">
            <div>
              <div className="about__description">
                <h2>{t("about_title")}</h2>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("about_paragraph_1"),
                  }}
                />
                {!t("about_paragraph_2").includes("Velit officia consequat") &&
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("about_paragraph_2"),
                  }}
                />
                }
              </div>
              <Button as={Link} to={startUrl} className="contribute-desktop">{t("contribute_btn")}</Button>
            </div>
            <MediaList useTranslate={useTranslate} media={media} />
            <Button as={Link} to={startUrl} className="contribute-mobile">{t("contribute_btn")}</Button>
          </div>

          <div className="section-bg">
            <img src={FrontSection2Bg} alt="Shapes"/>
          </div>
        </section>
        <section
          ref={(ref) => {
            this.rulesRef = ref;
          }}
          className="rules d-flex flex-column"
        >
          <div className="rules__header d-flex flex-column">
            <div className="serif-text-lg">{t("rules_welcome")}</div>
            <h3>{t("rules_title")}</h3>
          </div>

          <div className="rules__descriptions d-flex justify-content-between">
            <div className="rules__descriptions__description">
              <img alt="" src={isRetina(RuleOne1x, RuleOne2x)} />
              <h5>{t("rule_1_title")}</h5>
              <div>{t("rule_1_text")}</div>
            </div>

            <div className="rules__descriptions__description">
              <img alt="" src={isRetina(RuleTwo1x, RuleTwo2x)} />
              <h5>{t("rule_2_title")}</h5>
              <div>{t("rule_2_text")}</div>
            </div>

            <div className="rules__descriptions__description">
              <img alt="" src={isRetina(RuleThree1x, RuleThree2x)} />
              <h5>{t("rule_3_title")}</h5>
              <div>{t("rule_3_text")}</div>
            </div>
          </div>
          <Button as={Link} to={startUrl} className={"rules-btn"}>{t("rules_btn")}</Button>
        </section>
        <footer className="w-100 d-flex align-items-center justify-content-between">
          <div>©{new Date().getFullYear() + " " + t("trademark")}</div>
          <div className="d-flex">
            {this.getPrivacyPolicyLabel(languageCode, surveyId)}
            {this.renderPrivacyPolicy()}
          </div>
        </footer>
      </div>
    );
  }
}

export default LandingPage


// WEBPACK FOOTER //
// ./src/components/landing-page.js